import React, { useState } from 'react'
import { Building2, Truck } from 'lucide-react'
import { cn } from '@wove/web-ui'
import CargowiseOrganizations from './CargowiseOrganizations'
import CargowiseHandlingMethods from './CargowiseHandlingMethods'

const tabs = [
  {
    id: 'cargowise-organizations',
    label: 'Organizations',
    icon: <Building2 className="h-4 w-4" />,
  },
  {
    id: 'cargowise-handling-methods',
    label: 'Handling Methods',
    icon: <Truck className="h-4 w-4" />,
  },
]

export default function CargowiseReferencePage() {
  const [activeTab, setActiveTab] = useState('cargowise-organizations')

  return (
    <div className="p-6 max-w-6xl">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">CargoWise Reference Data</h1>
        <p className="text-lg text-gray-600">
          Browse and search CargoWise organizations and handling methods.
        </p>
      </div>

      {/* Tabs */}
      <div className="border-b border-gray-200 mb-6">
        <nav className="-mb-px flex space-x-8">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={cn(
                'flex items-center gap-2 py-2 px-1 border-b-2 font-medium text-sm whitespace-nowrap',
                activeTab === tab.id
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              )}
            >
              {tab.icon}
              {tab.label}
            </button>
          ))}
        </nav>
      </div>

      {/* Tab Content */}
      <div className="bg-white">
        {activeTab === 'cargowise-organizations' && <CargowiseOrganizations />}
        {activeTab === 'cargowise-handling-methods' && <CargowiseHandlingMethods />}
      </div>
    </div>
  )
}